import type { ChatEntitySearchResultsEmbed } from "./types";

export function entitySearchMatchSummary(embed: ChatEntitySearchResultsEmbed): string {
  const countPart =
    embed.title ||
    `${embed.total_count} match${embed.total_count === 1 ? "" : "es"}`;
  const withTruncation = embed.truncated ? `${countPart} · showing ${embed.candidates.length}` : countPart;
  const labels = embed.candidates
    .slice(0, 2)
    .map((candidate) => candidate.label.trim())
    .filter(Boolean);
  if (!labels.length) {
    return withTruncation;
  }
  const preview = labels.join(", ");
  const suffix = embed.candidates.length > labels.length ? "…" : "";
  return `${withTruncation} · ${preview}${suffix}`;
}

/** Embeds without `presentation` predate step/deliverable tagging and render expanded. */
export function isDeliverableSearchEmbed(embed: ChatEntitySearchResultsEmbed): boolean {
  return embed.presentation !== "step";
}
